


































import { computed, defineComponent, PropType } from "@vue/composition-api";
import { ReportReason } from "@scrile/api-provider/dist/api/ReportsProvider";
import { $t } from "@/lib/i18nHelpers";
import { FormFields, FormFileUpload, FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";
import BaseInputTextarea from "@/components/BaseInputTextarea";
import UploadFilesArea from "@/components/UploadFilesArea";

export default defineComponent({
  name: "ReportProofsForm",
  components: { BaseForm, UploadFilesArea, BaseInputTextarea },
  props: {
    processing: { type: Boolean, default: false },
    selectedReasons: { type: Array as PropType<ReportReason[]>, default: () => [] },
    fileList: { type: Array as PropType<FormFileUpload[]>, required: true },
    isLoggedIn: { type: Boolean, required: true },
    comment: { type: String, default: "" },
    guestInfoValues: { type: Object as PropType<FormValues>, default: () => ({}) },
  },
  setup(props) {
    const selectedReasonsString = computed(() => props.selectedReasons.map(i => i.title).join(", "));

    const guestInfoFields = computed<FormFields>(() => [
      {
        name: "email",
        label: $t("Email"),
        type: "email",
        rules: ["required"],
        validationMode: "aggressive",
      },
      {
        name: "name",
        label: $t("Name"),
        type: "text",
      },
    ]);

    return {
      selectedReasonsString,
      guestInfoFields,
    };
  },
});
